import { useState } from 'react';
import style from './accordion.module.scss'
import Link from 'next/link'
import { useRouter } from 'next/router';
import Image from 'next/image'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'
import { IAccordionTextItem } from '../discovery.state';

interface AccordionItemProps {
    id: number;
    title: string;
    text: IAccordionTextItem[];
}

const AccordionItem = ({ id, title, text }: AccordionItemProps) => {
    const router = useRouter();
    const [opened, setOpened] = useState(false);

    return (
        <>
            <hr />
            <div className={opened ? `${style.item__block} ${style.item__block_opened}` : style.item__block}>
                <Link href={router.asPath} scroll={false}>
                    <a onClick={() => setOpened(!opened)}>
                        <div className={`${style.item}`}>
                            <div className={`${style.number__block} ${style.item__number}`}>
                                {id}
                            </div>
                            <div className={style.item__block__text}>
                                <div className={`${style.item__title} ${style.title}`}>
                                    {title}
                                </div>
                                <div className={style.item__btn}>
                                    <Image sizes="100px" alt="accordion-icon" layout={'fill'} src='/discovery-images/ic-plus.png' />
                                </div>
                            </div>
                        </div>
                    </a>
                </Link>
                <div className={style.item__text}>
                    {
                        text.map((item: IAccordionTextItem, index: number) => {
                            switch(item.type) {
                                case 'text': return (
                                    <div key={index} className={style.text}>
                                        {item.text}
                                    </div>
                                )
                                case 'item': return (
                                    <div key={index} className={style.list__item}>
                                        {item.text}
                                    </div>
                                )
                            }
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default AccordionItem;
